export default str => str !== '';
